'use client';
import { Box, Flex, Text } from '@chakra-ui/react';
import NextImage from 'next/image';
import { SafeLink } from '@/components/ui/SafeLink';
import { format } from 'date-fns';

type BlogCardProps = {
  title: string;
  image: string;
  date: string;
  readTime: string;
  link: string;
};

const BlogPostCard = ({ title, image, date, readTime, link }: BlogCardProps) => {
  return (
    <SafeLink href={link} style={{ textDecoration: 'none' }} width="100%">
      <Flex cursor="pointer" direction="column" width="100%" marginBottom={{ base: 4, mobile: 8, desktop: 0 }}>
        <Box
          alignItems="center"
          backgroundColor="neutral.10"
          borderRadius="8px"
          display="flex"
          height={{ base: '160px', mobile: '170px', desktop: '300px' }}
          justifyContent="center"
          marginBottom={6}
          overflow="hidden"
          position="relative"
          width="100%"
          transition="transform 0.3s ease"
          _hover={{ transform: 'scale(1.03)' }}
        >
          <Box height="100%" position="relative" width="100%" zIndex={2}>
            <NextImage
              alt={title}
              fill
              src={image}
              sizes="(max-width: 480px) 100vw, (max-width: 768px) 50vw, (max-width: 1280px) 33vw, 25vw"
              priority
              style={{
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>
        <Flex direction="column" gap={4} width="100%">
          <Text color="neutral.100" textStyle="body3" fontWeight="regular" lineClamp={2}>
            {title}
          </Text>
          <Flex alignItems="center" justifyContent="space-between">
            <Text color="neutral.60" textStyle="body3">
              {format(date, 'd LLL, yyyy')}
            </Text>
            <Text color="neutral.60" textStyle="body3">
              {readTime}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </SafeLink>
  );
};

export default BlogPostCard;
